import { Box, Divider } from "@mui/material";
import PreviewItem from "./previewSections/PreviewItem";
import TopCard from "./previewSections/TopCard";
import InterestQuerySection from "./previewSections/InterestQuerySection";
import Details from "./previewSections/Details";
import Requirements from "./previewSections/Requirements";
import AdditionalInfo from "./previewSections/AdditionalInfo";
import { useFormContext } from "react-hook-form";
import { useAppSelector } from "../../../../../app/hooks";

const LongOrderWorkAgreementPreview = () => {
  const { workTitle, tes } = useAppSelector((state) => state.localized);
  const { watch } = useFormContext();
  const { orderTemplate } = watch();

  const localizedWorkTitle =
    orderTemplate?.workTitleId && workTitle[orderTemplate.workTitleId];
  const tesName = tes[orderTemplate?.tesId] || "";

  return (
    <Box>
      <PreviewItem workTitle={localizedWorkTitle} />
      <Box
        sx={{
          margin: "16px 0px 16px 16px",
          borderRadius: "12px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          width: "100%",
          maxWidth: "400px",
          backgroundColor: "#ffffff",
        }}
      >
        <TopCard workTitle={localizedWorkTitle} />
        <InterestQuerySection />
        <Details tesName={tesName} />
        <Divider sx={{ margin: "0 auto", width: "90%" }} />
        <Requirements />

        <AdditionalInfo />
      </Box>
    </Box>
  );
};

export default LongOrderWorkAgreementPreview;
